var _rect, _rect2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLystoLogoRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_341_3295)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 153,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_341_3295",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "#1A5BF6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_341_3295)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "#1A5BF6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.56 126C219.891 126 208 137.891 208 152.56V209H151.56C136.891 209 125 220.891 125 235.56V348.44C125 363.109 136.891 375 151.56 375H264.44C279.109 375 291 363.109 291 348.44V292H347.44C362.109 292 374 280.109 374 265.44V152.56C374 137.891 362.109 126 347.44 126H234.56ZM291 292V235.56C291 220.891 279.109 209 264.44 209H208V265.44C208 280.109 219.891 292 234.56 292H291Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_341_3295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 153,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLystoLogoRound);
export default __webpack_public_path__ + "static/media/lysto-logo-round.68d7c897996cec36830c8db6a662b2b8.svg";
export { ForwardRef as ReactComponent };